import { useState } from 'react'
import { ComponentWizard } from '../components/admin/builder/ComponentWizard'
import { ComponentList } from '../components/admin/builder/ComponentList'
import { DashboardList } from '../components/admin/builder/DashboardList'
import { CategoryList } from '../components/admin/builder/CategorieList'
import { DashboardEditor } from '../components/admin/builder/DashboardEditor'

type MainTab = 'components' | 'dashboards'| 'categories'
type SubView = 'list' | 'wizard' | 'editor'

export function BuilderPage() {
  const [mainTab, setMainTab] = useState<MainTab>('components')
  const [subView, setSubView] = useState<SubView>('list')
  const [editingDashboardId, setEditingDashboardId] = useState<string | null>(null)
  const [editingComponentId, setEditingComponentId] = useState<string | null>(null)

  const handleEditDashboard = (dashboardId: string) => {
    setEditingDashboardId(dashboardId)
    setSubView('editor')
  }

  const handleEditComponent = (componentId: string) => {
    setEditingComponentId(componentId)
    setSubView('wizard')
  }

  const handleBackToList = () => {
    setSubView('list')
    setEditingDashboardId(null)
    setEditingComponentId(null)
  }

  return (
    <div className="max-w-7xl mx-auto">
      {/* Tabs Header */}
      <div className="mb-8 border-b-2 border-gray-200">
        <div className="flex gap-1">
          <button
            onClick={() => {
              setMainTab('components')
              setSubView('list')
            }}
            className={`px-6 py-3 font-semibold transition-colors border-b-2 -mb-0.5 ${
              mainTab === 'components'
                ? 'border-green-600 text-green-600'
                : 'border-transparent text-gray-600 hover:text-gray-900'
            }`}
          >
            📊 Componentes
          </button>
          <button
            onClick={() => {
              setMainTab('dashboards')
              setSubView('list')
            }}
            className={`px-6 py-3 font-semibold transition-colors border-b-2 -mb-0.5 ${
              mainTab === 'dashboards'
                ? 'border-green-600 text-green-600'
                : 'border-transparent text-gray-600 hover:text-gray-900'
            }`}
          >
            🎨 Dashboards
          </button>
          <button
            onClick={() => {
              setMainTab('categories')
              setSubView('list')
            }}
            className={`px-6 py-3 font-semibold transition-colors border-b-2 -mb-0.5 ${
              mainTab === 'categories'
                ? 'border-green-600 text-green-600'
                : 'border-transparent text-gray-600 hover:text-gray-900'
            }`}
          >
            Categorías y Sub Categorías
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {/* Components Tab */}
        {mainTab === 'components' && (
          <>
            {subView === 'wizard' ? (
              <div>
                <div className="mb-4">
                  <button
                    onClick={handleBackToList}
                    className="px-4 py-2 text-green-600 hover:bg-green-50 rounded-lg font-medium transition-colors flex items-center gap-2"
                  >
                    ← Volver a la lista
                  </button>
                </div>
                <ComponentWizard
                  editingComponentId={editingComponentId}
                  onComplete={handleBackToList}
                />
              </div>
            ) : (
              <ComponentList
                onCreateNew={() => {
                  setEditingComponentId(null)
                  setSubView('wizard')
                }}
                onEditComponent={handleEditComponent}
              />
            )}
          </>
        )}

        {/* Dashboards Tab */}
        {mainTab === 'dashboards' && (
          <>
            {subView === 'editor' && editingDashboardId ? (
              <DashboardEditor
                dashboardId={editingDashboardId}
                onBack={handleBackToList}
              />
            ) : (
              <DashboardList onEditDashboard={handleEditDashboard} />
            )}
          </>
        )}

        {/* Categories Tab */}
        {mainTab === 'categories' && (
          <>
            {subView === 'editor' && editingDashboardId ? (
              <DashboardEditor
                dashboardId={editingDashboardId}
                onBack={handleBackToList}
              />
            ) : (
              <CategoryList />
            )}
          </>
        )}
      </div>
    </div>
  )
}
